export enum UserPermission {
	LeadCreate = "LEAD_CREATE",
	LeadView = "LEAD_VIEW",
	LeadNotes = "LEAD_NOTES",
	LeadEdit = "LEAD_EDIT",
	LeadQuotes = "LEAD_QUOTES",
	SiteView = "SITE_VIEW",
	ScheduleMap = "SCHEDULE_MAP",
	ScheduleAppointments = "SCHEDULE_APPOINTMENTS",
	AdminAll = "ADMIN_ALL",
	AdminUsers = "ADMIN_USERS",
	AdminPartnerBrands = "ADMIN_PARTNER_BRANDS",
	AdminMerchantBranchLocations = "ADMIN_MERCHANT_BRANCH_LOCATIONS",
	CrmLogin = "CRM_LOGIN",
	RewardsManagement = "REWARDS_MANAGEMENT",
	PartnerQuoteEmailTemplate = "PARTNER_QUOTE_EMAIL_TEMPLATE",
	ContactArchive = "CONTACT_ARCHIVE",
	LeadStatusUpdate = "LEAD_STATUS_UPDATE",
	JobStatusUpdate = "JOB_STATUS_UPDATE"
}
